import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLinkBox24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLinkBox24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 5.5h14A1.5 1.5 0 0 1 20.5 7v10a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 17V7A1.5 1.5 0 0 1 5 5.5M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm7 1.25a3.75 3.75 0 1 0 0 7.5h1a.75.75 0 0 0 0-1.5H9a2.25 2.25 0 0 1 0-4.5h1a.75.75 0 0 0 0-1.5zm6 7.5a3.75 3.75 0 1 0 0-7.5h-1a.75.75 0 0 0 0 1.5h1a2.25 2.25 0 0 1 0 4.5h-1a.75.75 0 0 0 0 1.5zM9 12a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 9 12"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLinkBox24);
